define([
    "jquery",
    "underscore",
    "marionette",
    "google_analytics"
], function($, _, Marionette, GoogleAnalytics) {

    var g_max;

    let gaCount = 1;

    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
        },

        ui: {
            'iframe' : '#iframe',
            'mt4AccountNo' : '#mt4_account_no',
            'currency' : '#currency_abbr',
            'iframeStyle' : '.cc_iframe iframe .form-control'
        },

        events:{
            'click @ui.lookupBalance': 'lookupBalance',
            'click @ui.submit' : 'deposit',
            'change @ui.mt4AccountNo' : 'sendData',
            'change @ui.currency' : 'sendData',
            'iframeStyle':'customIframe'
        },

        initialize: function() {
            this.bindUIElements();
            this.addEventListeners();
            this.requestLeftDepositAmount(this.ui.mt4AccountNo.val(), this.ui.currency.val())
                .then(function (res) {
                    g_max = res.max;
                })

            $('#iframe').on('load', function () {
                let urlKey = `credit_card_step${gaCount}`;
                GoogleAnalytics.sendGaPageviewEvent(GoogleAnalytics.googleAnalyticsUrls[urlKey]);
                gaCount++;
            });
        },

        requestLeftDepositAmount: function(mt4_account_no, selected_currency) {
            return $.ajax({
                url: baseUrl + 'rest_deposit/left_deposit_amount',
                method: 'GET',
                data: {
                    mt4_account_no: mt4_account_no,
                    selected_currency: selected_currency,
                },
            })
        },

        addEventListeners: function(){
            var that = this;
            window.addEventListener('message', function(e) {
                if(e.data === 'IFRAME_LOADED') {
                    that.sendMessage({
                        "mt4_account_no": that.ui.mt4AccountNo.val(),
                        "currency": that.ui.currency.val(),
                        "max": g_max
                    });
                }
                if(e.data === 'PAYMENT_PROCESSING'){
                    that.stretchIframe();
                }
                if(e.data === 'PAYMENT_ERROR'){
                    that.shrinkIframe();
                }
                if(e.data === 'PAYMENT_SUCCESS'){
                    that.shrinkIframe();
                }


                if(e.data === '3DS_START'){
                    console.log("3DS_START");
                    that.stretchIframe();
                }
                if(e.data === '3DS_END'){
                    console.log("3DS_END");
                    that.shrinkIframe();
                }
            });
        },

        stretchIframe: function(e) {
            if(e) e.preventDefault();
            this.ui.iframe.css({
                'height' : '700px'
            });
        },

        shrinkIframe: function(e) {
            if(e) e.preventDefault();
            this.ui.iframe.css({
                'height': '300px'
            })
        },

        sendData: function(){
            var that = this;
            that.requestLeftDepositAmount(that.ui.mt4AccountNo.val(), that.ui.currency.val())
                .then(function(res) {
                    g_max = res.max
                    that.sendMessage({
                        "mt4_account_no" : that.ui.mt4AccountNo.val(),
                        "currency" : that.ui.currency.val(),
                        "max": g_max
                    });
                });
        },

        sendMessage: function(data){
            var iframe = document.getElementById('iframe').contentWindow;
            iframe.postMessage(data, '*');
        },

        customIframe : function (){
            iframeStyle.addClass('reset-input');
        },
    });
});